import React, {Component} from 'react'
import {Auth0Context} from './contexts/auth-context'
import {getCadsCacheMinify} from './components/cads/cache/minify'
import {getEstimatesCache, qbApiOrgIds} from './components/cads2/get-estimates-cache'
import {getShippedCache} from './components/cads2/get-shipped'
import {Transition, Icon, Popup, Button, Modal, Table} from 'semantic-ui-react'
import {sortMapNameOptions} from './components/purchase-orders/sort-map-id-name-options.js'
import {repOptions} from './components/vendor-orders/options.js'
import {sliceAdd} from './components/vendor-orders/slice-add'
import CadCards from './components/cads2/cards'
import {filtersButton} from './components/prints/filters-button'
import CadFilters from './components/cads2/filters'
import {filterCads, roundTens} from './components/cads2/filter'
import ChatButton from './components/cads2/chat'
import ClaudeChatButton from './components/cads2/claude-chat'
import BulkButtons from './components/cads2/bulk-buttons'
import SearchInput from './components/vendor-orders/search-inputs'
import $ from 'jquery'
import {getAccountOptions, getGroupedAccountOptions} from './components/cads/get-account-options'
import Graph from './components/cads2/graph'
import {getVendorOrders} from './components/cads2/get-vendor-orders'
import {getReceivedContainers} from './components/cads2/get-received-containers'
import {getInventoryAdjustments} from './components/cads2/get-inventory-adjustments'
import {getAtsRep} from './components/cads2/get-ats-rep'
import {getTicketInfo} from './components/cads2/get-ticket-info'
import {getPoeInfo} from './components/cads2/get-poe-info'
import TotalsBox from './components/cads2/totals-box'
import ReportProcessing from './components/cads2/report-processing'
import {brandOptions, divisionOptions, categoryOptions} from './components/generate-style-number/options'
import FoundPoNumberBox from './components/cads2/found-po-number-box'
import {filterSalesData} from './components/cads2/filter-sales-data'
import './components/cads2/back-to-top.css'
import {processText} from './components/new-vpo-page/select-cads/process-text'
import ContainerNumberTotals from './components/cads/container-number-totals'
import {isCustomer, isAdmin} from './components/cads/is-role'
import {canSeeContainerTotals, canSeeTotals} from './components/custom-access/can'
import {checkAdminPin} from './components/admin/pin.js'
import {markAsBestSellerModals} from './components/best-sellers/mark-as-modals'
import {bestSellerSuccess} from './components/best-sellers/success'
import {saveBestSellerCads2} from './components/best-sellers/save-cads2'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as cadActions from './actions/cadActions'
import {accountName} from './components/cads/unminify'

const maxUnits = 5000
const maxDays = 800

const parseDate = (cad) => {
  const str = cad.c.replace('  ',' ')
  const dateString = str.split(' ')[0]
  const parts = dateString.split("/")
  const year = parseInt(parts[2], 10)
  // Note: Months in JavaScript are zero-indexed (0-11)
  const month = parseInt(parts[0], 10) - 1
  const day = parseInt(parts[1], 10)

  const timeString = str.split(' ')[1]
  const timeParts = timeString.split(':')
  const hour12 = parseInt(timeParts[0], 10)
  const minute = parseInt(timeParts[1], 10)
  const ampm = str.split(' ')[2]

  let hour24 = hour12

  if (ampm.toUpperCase() === 'PM' && hour12 < 12) {
    hour24 += 12 // Add 12 for PM hours (except 12 PM which remains 12)
  } else if (ampm.toUpperCase() === 'AM' && hour12 === 12) {
    hour24 = 0 // 12 AM (midnight) becomes 0 in 24-hour format
  }

  const parsedDate = new Date(year, month, day, hour24, minute)

  return parsedDate
}

const compareDate = (a, b) => {
  if (parseDate(a) < parseDate(b))
      return 1;
  if (parseDate(a) > parseDate(b))
      return -1;
  return 0;
}

const clearFiltersState = {
  color: [],
  category: [],
  subcategory: [],
  sub2: [],
  fabrication: [],
  sizes: [],
  brand: [],
  division: [],
  packs: [],
  sliceNum: 200,
  minAts: 0,
  maxAts: maxUnits,
  minFutureAts: 0,
  maxFutureAts: maxUnits,
  minOnHand: 0,
  maxOnHand: maxUnits,
  minPendingPo: 0,
  maxPendingPo: maxUnits,
  minAge: 0,
  maxAge: maxDays,
  filteredCads: [],
  statuses: [],
  searchString: '',
  contact: [],
  season: [],
  status: null,
  futureAts: [],
  fromDate: null,
  toDate: null,
  rep: null,
  groupId: null,
  cadIds: {},
  allSelected: false,
  warehouse: [],
  factory: [],
  foundPoNumber: null,
  notFoundStyleNumbers: []
}

class CadsPage2 extends Component {

  static contextType = Auth0Context

  constructor(props) {
    super(props)
    window.upcsTotals = window.upcsTotals || {}
    window.upcs = window.upcs || {}
    this.state = {
      cads: [],
      shippedData: {},
      vendorOrders: [],
      receivedContainers: {},
      inventoryAdjustments: {},
      salesOrderData: {},
      atsRep: {},
      ticketInfo: {},
      poeInfo: {},
      filteredCads: [],
      notFoundStyleNumbers: [],
      cadLoading: true,
      shippedLoading: true,
      estimatesLoading: true,
      sliceNum: 200,
      color: [],
      category: [],
      subcategory: [],
      sub2: [],
      fabrication: [],
      sizes: [],
      brand: [],
      division: [],
      packs: [],
      minAts: 0,
      maxAts: maxUnits,
      minFutureAts: 0,
      maxFutureAts: maxUnits,
      minOnHand: 0,
      maxOnHand: maxUnits,
      minPendingPo: 0,
      maxPendingPo: maxUnits,
      minAge: 0,
      maxAge: maxDays,
      statuses: [],
      searchString: '',
      contactOptions: [],
      contact: [],
      season: [],
      status: null,
      sortBy: 'Sort by: Search textbox',
      expandAll: false,
      laFashionCombine: false,
      futureAts: [],
      fromDate: null,
      toDate: null,
      rep: null,
      showFields: ['ATS', 'Future ATS'],
      groupId: null,
      cadIds: {},
      allSelected: false,
      reportId: null,
      warehouse: [],
      factory: [],
      foundPoNumber: null, //{ponumber: '12341234', accountName: 'TJX/MARSHALLS', orderType: 'PO', startShip: '08/01/2026'}
      shareOrderTypeCategory: null,
      showShareOrderTypeCategoryMessage: true,
      showBackToTop: false,
      correctPin: false,
      // seller-status (Best / Average / Poor) bulk workflow
      salesHistoryAccounts: [],
      poorSellerAccount: '',
      averageSellerAccount: '',
      bestSellerAccount: '',
      poorSellerModalOpen: false,
      averageSellerModalOpen: false,
      bestSellerModalOpen: false,
      poorSellerSuccessVisible: false,
      averageSellerSuccessVisible: false,
      bestSellerSuccessVisible: false,
      shippedByCustomerOpen: false,
      shippedByCustomerRows: [],
    }
  }

  setPinTrue = () => {
    this.setState({correctPin: true})
  }

  setPinFalse = () => {
    this.setState({correctPin: false})
  }

  componentDidMount() {
    this.setOptions()
    if (isCustomer()) this.setCustomerContact()
    window.addEventListener('set-admin-pin-true', this.setPinTrue)
    window.addEventListener('set-admin-pin-false', this.setPinFalse)
    checkAdminPin()
    window.addEventListener('scroll', this.updateBackToTopVisibility)
    this.updateBackToTopVisibility()
    window.addEventListener('bestSellerTotalsUpdated', this.onBestSellerTotalsUpdated)
    window.addEventListener('buyerReviewUpdated', this.onBuyerReviewUpdated)
  }

  componentWillUnmount() {
    window.removeEventListener('set-admin-pin-true', this.setPinTrue)
    window.removeEventListener('set-admin-pin-false', this.setPinFalse)
    window.removeEventListener('scroll', this.updateBackToTopVisibility)
    window.removeEventListener('bestSellerTotalsUpdated', this.onBestSellerTotalsUpdated)
    window.removeEventListener('buyerReviewUpdated', this.onBuyerReviewUpdated)
  }

  // the edit-best-sellers popup fires this after saving so the card pills stay in sync
  // with the popup's live rows (best -> x, average -> av, poor -> z).
  onBestSellerTotalsUpdated = (e) => {
    let {cadId, bestSellerTotal, averageSellerTotal, poorSellerTotal} = e.detail || {}
    let {cads} = this.state
    for (let i = 0; i < cads.length; i++) {
      if (cads[i].i == cadId) {
        cads[i].x = bestSellerTotal
        cads[i].av = averageSellerTotal
        cads[i].z = poorSellerTotal
        break
      }
    }
    this.setState({cads})
  }

  onBuyerReviewUpdated = (e) => {
    let {cadId, buyerReviewTotal, totals} = e.detail || {}
    let {cads} = this.state
    for (let i = 0; i < cads.length; i++) {
      if (cads[i].i == cadId) {
        cads[i].br = buyerReviewTotal
        break
      }

      if (totals != null && totals[cads[i].i] != null) {
        cads[i].br = totals[cads[i].i]
      }
    }
    this.setState({cads})
  }

  updateBackToTopVisibility = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    const showBackToTop = scrollTop > 300

    if (showBackToTop !== this.state.showBackToTop) {
      this.setState({showBackToTop})
    }
  }

  scrollToTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  filterSalesData = (salesData, isShipped = false) => {
    let {user} = this.context
    let {shareOrderTypeCategory, cads} = this.state
    return filterSalesData(salesData, cads, user, shareOrderTypeCategory, isShipped)
  }

  setShareOrderTypeCategory = () => {
    let customAccess = JSON.parse(localStorage.getItem('customAccess'))
    let shareOrderTypeCategory = customAccess != null ? customAccess.shareOrderTypeCategory : null
    this.setState({shareOrderTypeCategory})
  }

  setCustomerContact = () => {
    let customAccess = JSON.parse(localStorage.getItem('customAccess'))
    let contact = customAccess != null ? [customAccess.quickbooksAccountName] : []
    this.setState({contact})
  }

  setOptions = () => {
    let {customer} = this.context
    if (customer == null) {
      setTimeout(this.setOptions, 500)
    } else {
      getCadsCacheMinify(customer.id, this.cadsSuccessCallback)
      getShippedCache(customer.id, this.shippedSuccessCallback)
      getVendorOrders(customer.id, this.vendorOrdersCallback)
      if (customer.id == 1) {
        getReceivedContainers(customer.id, this.receivedContainersCallback)
        getInventoryAdjustments(customer.id, this.inventoryAdjustmentsCallback)
      }
      
      getTicketInfo(this.ticketInfoCallback)
      getPoeInfo(this.poeInfoCallback)
      if (!qbApiOrgIds.includes(customer.id)) {
        getAtsRep(customer.id, this.atsRepCallback)
      }

      this.setShareOrderTypeCategory()

      if (qbApiOrgIds.includes(customer.id)) {
        setTimeout(() => {
          this.setState({shippedLoading: false})
        }, 1000)
      }

      getEstimatesCache(customer.id, this.estimatesSuccessCallback)

    }
  }

  atsRepCallback = (atsRep) => {
    this.setState({atsRep})
  }

  ticketInfoCallback = (ticketInfo) => {
    this.setState({ticketInfo})
  }

  poeInfoCallback = (poeInfo) => {
    this.setState({poeInfo})
  }

  vendorOrdersCallback = (vendorOrders) => {
    this.setState({vendorOrders})
  }

  receivedContainersCallback = (receivedContainers) => {
    this.setState({receivedContainers})
  }

  inventoryAdjustmentsCallback = (inventoryAdjustments) => {
    this.setState({inventoryAdjustments})
  }

  cadsSuccessCallback = (cads) => {
    let filteredCads = cads.filter(cad => cad.s != null && cad.s.length > 4)

    this.setState({cadLoading: false, cads: filteredCads}, () => {
      setTimeout(() => {
        if (isCustomer()) {
          this.fieldOnChange(null, {value: 'Future ATS', name: 'status'})
          this.setState({showFields: ['Future ATS']})
        } else {
          this.fieldOnChange(null, {value: 'ATS or Future ATS', name: 'status'})
        }
      }, 10)
    })
  }

  combineCads = (callback) => {
    let {cads} = this.state
    let combinedCads = {}

    cads.forEach((cad) => {
      let parts = cad.s.split('-')
      let root = parts[0]
      let size = parts[2] == null ? null : parts[2].toUpperCase()
      let color = parts[1] == null ? null : parts[1].toUpperCase()

      if (combinedCads[root] == null) {
        combinedCads[root] = {
          i: cad.i, s: root, cads: [], available: [], f: null, a: 0, y: 0,
          c: cad.c,
          b: cad.b,
          d: cad.d,
          g: cad.g,
          p: cad.p,
          e: cad.e
        }
      }

      combinedCads[root]['cads'].push(cad)
      combinedCads[root]['available'].push({size, color, available: cad.a})
      combinedCads[root]['a'] += cad.a
      if (combinedCads[root]['f'] == null) {
        combinedCads[root]['f'] = cad.f
      }
      if (cad.y > 0) {
        combinedCads[root]['y'] += cad.y
      }

    })

    this.setState({combinedCads: Object.values(combinedCads)}, callback)
  }

  estimatesSuccessCallback = (estimates, vendorOrders, invoices) => {
    this.setState({estimatesLoading: false, estimates, vendorOrders, shippedData: invoices})
  }

  shippedSuccessCallback = (shippedData, salesOrderData) => {
    let {cadLoading} = this.state

    if (cadLoading) {
      setTimeout(() => this.shippedSuccessCallback(shippedData, salesOrderData), 500)
    } else {
      shippedData = this.filterSalesData(shippedData, true)
      salesOrderData = this.filterSalesData(salesOrderData)
      let contactOptions = getGroupedAccountOptions(shippedData, salesOrderData)
      let salesHistoryAccounts = getAccountOptions(shippedData, salesOrderData)
      this.setState({shippedData, salesOrderData, contactOptions, salesHistoryAccounts, shippedLoading: false})
    }
  }

  loadMore = () => {
    this.setState({sliceNum: this.state.sliceNum + sliceAdd})
  }

  markCadAsDeleted = (id) => {
    let {cads} = this.state
    for (let i=0;i<cads.length;i++) {
      if (cads[i].i == id) {
        cads[i].is_deleted = true
        break
      }
    }
    this.setState({cads})
  }

  fieldOnChange = (event, {value, name}, filterCads = true) => {
    let newState = {}

    if (['status','rep'].includes(name) && value == 'All') {
      newState[name] = null
    } else {
      newState[name] = value
    }

    if (name == 'futureAts' && this.state.status == 'ATS') {
      newState['status'] = null
    }

    if (name == 'status') {
      ['PO', 'Pending PO', 'Hold', 'Worksheet', 'On Hand', 'Age', 'Season', 'Container #', 'Shipped','ATS', 'Future ATS', 'Future Stock', 'ATS Rep', 'Sizes', 'Warehouse', 'Sub2'].forEach((field) => {
        if (value == field && !this.state.showFields.includes(field)) {
          this.showFieldOnChange(field)
        }
      })

      if (value == 'Ready To Ship') {
        ['PO', 'On Hand'].forEach((field) => {
          if (!this.state.showFields.includes(field)) {
            this.showFieldOnChange(field)
          }
        })
      }
    }

    if (name == 'status' && value == 'Duplicate VPO' && !this.state.showFields.includes('Future Stock')) {
      this.showFieldOnChange('Future Stock')
    }

    if (name == 'warehouse' && !this.state.showFields.includes('Warehouse')) {
      this.showFieldOnChange('Warehouse')
    }

    if (name == 'sortBy' && value == 'Sort by: Most shipped' && !this.state.showFields.includes('Shipped')) {
      this.showFieldOnChange('Shipped')
    }

    this.setState(newState)
    if (filterCads) {
      this.filterCads()
    }

  }

  clearFilters = () => {
    this.setState(clearFiltersState)
    $('.cads-date-input').val('')

    const textarea = document.getElementById('vpo-bulk-search')
    textarea.value = ''

    if (isCustomer()) this.setCustomerContact()
  }

  usingFilters = () => {
    let {searchString, color, category, subcategory, sub2, fabrication, sizes, brand, division, packs, minAts, maxAts, minFutureAts, maxFutureAts, minAge, maxAge, minOnHand, maxOnHand, minPendingPo, maxPendingPo, status, futureAts, fromDate, toDate, warehouse, factory, rep, season} = this.state
    return (
      searchString != '' || roundTens(minAts) != 0 || roundTens(maxAts) != maxUnits || roundTens(minFutureAts) != 0 || roundTens(maxFutureAts) != maxUnits || roundTens(minOnHand) != 0 || roundTens(maxOnHand) != maxUnits || roundTens(minPendingPo) != 0 || roundTens(maxPendingPo) != maxUnits || roundTens(minAge) != 0 || roundTens(maxAge) != maxDays ||
      color.length || category.length || subcategory.length || sub2.length || fabrication.length || sizes.length || brand.length || division.length || packs.length || status != null ||
      futureAts.length || fromDate != null || toDate != null || warehouse.length || factory.length || rep != null || season.length
    )
  }

  updateAtsValues = (sliderState) => {
    let {values} = sliderState
    let minAts = values[0]
    let maxAts = values[1]

    clearTimeout(window.updateAtsValuesTimeout)
    window.updateAtsValuesTimeout = setTimeout(() => {
      this.setState({minAts, maxAts})
      clearTimeout(window.filterCadsTimeout)
      window.filterCadsTimeout = setTimeout(this.filterCads, 100)
      if(!this.state.showFields.includes('ATS')) {
        this.showFieldOnChange('ATS')
      }
    }, 100)
  }

  updateFutureAtsValues = (sliderState) => {
    let {values} = sliderState
    let minFutureAts = values[0]
    let maxFutureAts = values[1]
    this.setState({minFutureAts, maxFutureAts})
    clearTimeout(window.filterCadsTimeout)
    window.filterCadsTimeout = setTimeout(this.filterCads, 1000)
    if(!this.state.showFields.includes('Future ATS')) {
      this.showFieldOnChange('Future ATS')
    }
  }

  updateAgeValues = (sliderState) => {
    let {values} = sliderState
    let minAge = values[0]
    let maxAge = values[1]
    this.setState({minAge, maxAge})
    clearTimeout(window.filterCadsTimeout)
    window.filterCadsTimeout = setTimeout(this.filterCads, 1000)
    if(!this.state.showFields.includes('Age')) {
      this.showFieldOnChange('Age')
    }
  }

  updateOnHandValues = (sliderState) => {
    let {values} = sliderState
    let minOnHand = values[0]
    let maxOnHand = values[1]
    this.setState({minOnHand, maxOnHand})
    clearTimeout(window.filterCadsTimeout)
    window.filterCadsTimeout = setTimeout(this.filterCads, 1000)
    if(!this.state.showFields.includes('On Hand')) {
      this.showFieldOnChange('On Hand')
    }
  }

  updatePendingPoValues = (sliderState) => {
    let {values} = sliderState
    let minPendingPo = values[0]
    let maxPendingPo = values[1]
    this.setState({minPendingPo, maxPendingPo})
    clearTimeout(window.filterCadsTimeout)
    window.filterCadsTimeout = setTimeout(this.filterCads, 1000)
    if(!this.state.showFields.includes('Pending PO')) {
      this.showFieldOnChange('Pending PO')
    }
  }

  filterCads = () => {
    setTimeout(() => {
      let {filteredCads, foundPoNumber, notFoundStyleNumbers} = filterCads(this.state, this.usingFilters(), maxUnits, maxDays)


      if (foundPoNumber != null) {
        let data = foundPoNumber
        let orderType = !!data.shipped ? 'Shipped' : (!data.shipped && !data.hold && !data.worksheet && !data.pending_po) ? 'PO' : !!data.hold ? 'Hold' : !!data.worksheet ? 'Worksheet' : !!data.pending_po ? 'Pending PO' : null

        if(!this.state.showFields.includes(orderType)) {
          this.showFieldOnChange(orderType)
        }
        this.setState({expandAll: true})
      }

      if (foundPoNumber != null && this.state.status == 'ATS or Future ATS') {
        this.setState({status: null})
        this.filterCads()
      } else {
        this.setState({filteredCads, foundPoNumber, notFoundStyleNumbers, cadIds: {}, allSelected: false, sliceNum: 200})
      }
    }, 0)
  }

  updateSearchString = (value) => {
    this.setState({
      ...clearFiltersState,
      searchString: value
    }, () => {
      if (isCustomer()) this.setCustomerContact()
      this.filterCads()
    })
  }

  fromDateOnChange = (e) => {
    let {value} = e.target
    if (value.trim() == '') {
      value = null
    }
    this.setState({fromDate: value})
    this.filterCads()
  }

  toDateOnChange = (e) => {
    let {value} = e.target
    if (value.trim() == '') {
      value = null
    }
    this.setState({toDate: value})
    this.filterCads()
  }

  compareSearchTextbox = (a, b) => {
    let {searchString} = this.state
    if (searchString.indexOf(a.s) < searchString.indexOf(b.s))
        return -1
    if (searchString.indexOf(a.s) > searchString.indexOf(b.s))
        return 1
    return 0
  }

  showFieldOnChange = (fieldName) => {
    let {showFields} = this.state
    if (showFields.includes(fieldName)) {
      showFields = showFields.filter(x => x != fieldName)
    } else {
      showFields.push(fieldName)
    }

    this.setState({showFields})
  }

  hideAllFields = () => {
    this.setState({showFields: []})
  }

  selectAll = () => {
    let {allSelected, filteredCads, cads, sliceNum} = this.state
    let results = this.usingFilters() ? filteredCads.slice(0) : cads.slice(0)

    if (allSelected) {
      this.setState({cadIds: {}, allSelected: false})
    } else {
      let cadIds = {}
      for (let i=0; i<results.length; i++) {
        let cadId = results[i].i
        cadIds[cadId] = true
      }
      this.setState({cadIds, allSelected: true})
    }
  }

  checkboxOnChange = (id) => {
    let {cadIds} = this.state

    if (cadIds[id] == null) {
      cadIds[id] = true
    } else {
      delete cadIds[id]
    }

    this.setState({cadIds})
  }

  createSalesOrder = () => {
    let keys = Object.keys(this.state.cadIds)
    if (keys.length == 0) {
      alert('Select at least 1 CAD')
      return
    }
    this.props.actions.bulkRemoveFromShoppingBag()
    this.props.actions.bulkAddToShoppingBag(keys)
    this.props.history.push('/sales-orders/new?from=cadspage')
  }

  expandAllOnChange = (e, data) => {
    this.setState({expandAll: data.checked})
  }

  // ----- seller-status (Best / Average / Poor) bulk workflow -----
  mySetState = (x) => this.setState(x)

  poorSellerAccountOnChange = (event, {value}) => this.setState({poorSellerAccount: value})
  averageSellerAccountOnChange = (event, {value}) => this.setState({averageSellerAccount: value})
  bestSellerAccountOnChange = (event, {value}) => this.setState({bestSellerAccount: value})

  markAsPoorSeller = () => {
    if (Object.keys(this.state.cadIds).length == 0) {
      alert('Select at least 1 CAD')
    } else {
      this.setState({poorSellerAccount: '', bestSellerSuccessVisible: false, poorSellerSuccessVisible: false, averageSellerSuccessVisible: false, poorSellerModalOpen: true})
    }
  }

  markAsAverageSeller = () => {
    if (Object.keys(this.state.cadIds).length == 0) {
      alert('Select at least 1 CAD')
    } else {
      this.setState({averageSellerAccount: '', bestSellerSuccessVisible: false, poorSellerSuccessVisible: false, averageSellerSuccessVisible: false, averageSellerModalOpen: true})
    }
  }

  markAsBestSeller = () => {
    if (Object.keys(this.state.cadIds).length == 0) {
      alert('Select at least 1 CAD')
    } else {
      this.setState({bestSellerAccount: '', bestSellerSuccessVisible: false, poorSellerSuccessVisible: false, averageSellerSuccessVisible: false, bestSellerModalOpen: true})
    }
  }

  saveBestPoorSeller = (bestOrPoor) => {
    saveBestSellerCads2(bestOrPoor, this.state, this.mySetState)
  }

  bestSellerModalClose = () => {
    this.setState({bestSellerModalOpen: false, poorSellerModalOpen: false, averageSellerModalOpen: false})
  }

  bestSellerSuccessHandleDismiss = () => this.setState({bestSellerSuccessVisible: false})
  averageSellerSuccessHandleDismiss = () => this.setState({averageSellerSuccessVisible: false})
  poorSellerSuccessHandleDismiss = () => this.setState({poorSellerSuccessVisible: false})

  laFashionCombineOnChange = (e, data) => {
    this.setState({laFashionCombine: data.checked}, () => {
      if (!data.checked) {
        this.filterCads()
        return
      }
      this.combineCads(() => this.filterCads())
    })
  }

  hideShareOrderTypeCategoryMessage = () => {
    this.setState({showShareOrderTypeCategoryMessage: false})
  }

  getSearchContainerNumbers = () => {
    let {searchString, vendorOrders} = this.state

    if (searchString.trim() == '') {
      return []
    }

    let searchStrings = processText(searchString)

    if (vendorOrders == null) {
      return []
    } else {
      return [...new Set(
        vendorOrders
          .map(x => x.container_number)
          .filter(x => x != null && searchStrings.includes(x))
      )]
    }
  }

  getSearchPendingContainerNumbers = () => {
    let {searchString, vendorOrders} = this.state

    if (searchString.trim() == '') {
      return []
    }

    let searchStrings = processText(searchString)

    if (vendorOrders == null) {
      return []
    } else {
      return [...new Set(
        vendorOrders
          .flatMap(x => (x.pending_container_number || '').split(',').map(s => s.trim()))
          .filter(x => x != '' && searchStrings.includes(x))
      )]
    }
  }

  openShippedByCustomer = () => {
    let {filteredCads, shippedData} = this.state
    let totals = {}

    filteredCads.forEach(cad => {
      let styles = cad.cads == null ? [cad.s] : cad.cads.map(x => x.s)
      styles.forEach(style => {
        (shippedData[style] || []).forEach(row => {
          let name = accountName(row) || 'Unknown'
          totals[name] = (totals[name] || 0) + Number(row.q || 0)
        })
      })
    })

    let rows = Object.keys(totals)
      .map(name => ({name, qty: totals[name]}))
      .sort((a, b) => b.qty - a.qty)

    this.setState({shippedByCustomerOpen: true, shippedByCustomerRows: rows})
  }

  closeShippedByCustomer = () => {
    this.setState({shippedByCustomerOpen: false})
  }

  render() {
    let {customer} = this.context
    let {
      cadLoading, shippedLoading, sliceAdd, sliceNum, colorOptions, color, category, subcategory, sub2, fabrication, sizes, brand, division, packs,
      minAts, maxAts, minFutureAts, maxFutureAts, minAge, maxAge, minOnHand, maxOnHand, minPendingPo, maxPendingPo, cads, filteredCads, shippedData, vendorOrders, salesOrderData, estimates,
      statuses, contactOptions, salesHistoryAccounts, contact, season, status, sortBy, expandAll, searchString, futureAts, atsRep, ticketInfo, poeInfo, rep, showFields, groupId, fromDate, toDate,
      cadIds, allSelected, reportId, warehouse, factory, foundPoNumber, shareOrderTypeCategory, showShareOrderTypeCategoryMessage, laFashionCombine,
      combinedCads, showBackToTop, notFoundStyleNumbers
    } = this.state

    let results
    if (laFashionCombine) {
      results = this.usingFilters() ? filteredCads.slice(0) : combinedCads.slice(0)
    } else {
      results = this.usingFilters() ? filteredCads.slice(0) : cads.slice(0)
    }

    if (sortBy == 'Sort by: Created') {
      results = results.sort(compareDate)
    } else if (sortBy == 'Sort by: Search textbox') {
      results = results.sort(this.compareSearchTextbox)
    } else if (sortBy == 'Sort by: Most shipped') {
      let qtyFor = (style) => (shippedData[style] || []).reduce((sum, row) => sum + Number(row.q), 0)
      let qty = {}

      results.forEach(cad => {
        let styles = cad.cads == null ? [cad.s] : cad.cads.map(x => x.s)
        qty[cad.s] = styles.reduce((sum, style) => sum + qtyFor(style), 0)
      })

      results = results.sort((a, b) => qty[b.s] - qty[a.s])
    }

    let searchContainerNumbers = this.getSearchContainerNumbers()
    let showContainerNumberTotals = searchContainerNumbers.length > 0 && (isAdmin() || canSeeContainerTotals())
    let searchPendingContainerNumbers = this.getSearchPendingContainerNumbers()
    let showPendingContainerNumberTotals = searchPendingContainerNumbers.length > 0 && (isAdmin() || canSeeContainerTotals())
    let canSeeTotalsBox = ['admin', 'superadmin', 'sales', 'sales_assistant'].includes(localStorage.getItem('currentUserRole')) || canSeeTotals()


    return (
      <Transition visible={!cadLoading && !shippedLoading} animation='fade' duration={3000}>
        <div style={{padding: '50px 60px', whiteSpace: 'nowrap'}}>
          <BulkButtons showFields={showFields} showFieldOnChange={this.showFieldOnChange}
            hideAllFields={this.hideAllFields} sortBy={sortBy} expandAll={expandAll}
            expandAllOnChange={this.expandAllOnChange} searchString={searchString} fieldOnChange={this.fieldOnChange}
            shippedData={shippedData} salesOrderData={salesOrderData} cads={results}
            contact={contact} contactOptions={salesHistoryAccounts} fromDate={fromDate} toDate={toDate} atsRep={atsRep}
            vendorOrders={vendorOrders}
            selectAll={this.selectAll} allSelected={allSelected} cadIds={cadIds}
            orgId={customer == null ? null : customer.id} laFashionCombine={laFashionCombine} laFashionCombineOnChange={this.laFashionCombineOnChange}
            markAsBestSeller={this.markAsBestSeller} markAsAverageSeller={this.markAsAverageSeller} markAsPoorSeller={this.markAsPoorSeller}
            createSalesOrder={this.createSalesOrder}
          />

          {markAsBestSellerModals(this.state, this.bestSellerModalClose, this.poorSellerAccountOnChange, this.averageSellerAccountOnChange, this.bestSellerAccountOnChange, this.saveBestPoorSeller)}
          {bestSellerSuccess(this.state, this.bestSellerSuccessHandleDismiss, this.averageSellerSuccessHandleDismiss, this.poorSellerSuccessHandleDismiss)}

          <Modal open={this.state.shippedByCustomerOpen} onClose={this.closeShippedByCustomer} size='small' closeIcon>
            <Modal.Header>Total shipped by customer</Modal.Header>
            <Modal.Content>
              <Table basic='very'>
                <Table.Body>
                  {this.state.shippedByCustomerRows.map(row =>
                    <Table.Row key={row.name}>
                      <Table.Cell>{row.name}</Table.Cell>
                      <Table.Cell textAlign='right'>{row.qty.toLocaleString()}</Table.Cell>
                    </Table.Row>
                  )}
                  <Table.Row>
                    <Table.Cell><b>Total</b></Table.Cell>
                    <Table.Cell textAlign='right'><b>{this.state.shippedByCustomerRows.reduce((s, r) => s + r.qty, 0).toLocaleString()}</b></Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={this.closeShippedByCustomer}>Close</Button>
            </Modal.Actions>
          </Modal>

          {
            reportId == null
            ?
            null
            :
            <ReportProcessing reportId={reportId} fieldOnChange={this.fieldOnChange}/>
          }

          {
            canSeeTotalsBox
            ?
            <TotalsBox results={results}
            shippedData={shippedData} salesOrderData={salesOrderData}
            status={status} contact={contact} fromDate={fromDate} toDate={toDate} rep={rep}/>
            :
            null
          }


          <ChatButton/>
          <ClaudeChatButton/>



          {
            foundPoNumber != null
            ?
            <FoundPoNumberBox data={foundPoNumber}/>
            :
            null
          }

          {
            shareOrderTypeCategory != null && showShareOrderTypeCategoryMessage
            ?
            <div style={{padding: '10px 20px', borderRadius: '10px', width: '400px', background: 'rgb(19, 28, 45)', color: 'white', border: '2px solid rgb(228, 203, 131)'}}>
              <Icon name='eye' style={{color: 'rgb(228,203,131)'}}/> You can see {shareOrderTypeCategory}

              <Popup content='Close' position='right center'
                trigger={
                  <Icon name='close' style={{color: 'rgb(228,203,131)', cursor: 'pointer', float: 'right'}}
                    onClick={this.hideShareOrderTypeCategoryMessage}
                  />
                }
              />

            </div>
            :
            null
          }


          {
            notFoundStyleNumbers != null && notFoundStyleNumbers.length > 0
            ?
            <div style={{boxShadow: '0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5', padding: '10px 20px', borderRadius: '.28571429rem', width: '360px', marginBottom: '20px'}}>
              <div style={{fontWeight: 'bold'}}><Icon name='list'/> SEARCHING MULTIPLE STYLE NUMBERS</div>

              <div style={{padding: '15px 0 0 0', lineHeight: '1.8rem'}}>
                The following are NOT found:
                <ul style={{margin: '5px 0 0 0'}}>
                  {notFoundStyleNumbers.map(x => <li key={x}>{x.toUpperCase()}</li>)}
                </ul>
              </div>
            </div>
            :
            null
          }

          <h3>{results.length} cad{results.length == 1 ? '' : 's'} found</h3>

          {
            isCustomer()
            ?
            null
            :
            <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '24px', marginBottom: '20px', width: '100%'}}>
              <div>
                <SearchInput updateSearchString={this.updateSearchString}
                  showBulk={true} statuses={statuses}
                  placeholder="Search for Cads, Container #, Pending Container #, PO #"
                />
              </div>

              {
                showContainerNumberTotals
                ?
                <ContainerNumberTotals
                  key={searchContainerNumbers.join('@@@')}
                  number=""
                  numbers={searchContainerNumbers}
                  style={{width: '360px'}}
                />
                :
                null
              }

              {
                showPendingContainerNumberTotals
                ?
                <ContainerNumberTotals
                  pending
                  key={'pending' + searchPendingContainerNumbers.join('@@@')}
                  number=""
                  numbers={searchPendingContainerNumbers}
                  style={{width: '360px'}}
                />
                :
                null
              }
            </div>
          }

          <CadFilters clearFilters={this.clearFilters}
            color={color} category={category} subcategory={subcategory} sub2={sub2} fabrication={fabrication} sizes={sizes}
            brand={brand} division={division} packs={packs}
            fieldOnChange={this.fieldOnChange} usingFilters={this.usingFilters}
            minAts={minAts}
            maxAts={maxAts}
            minOnHand={minOnHand}
            maxOnHand={maxOnHand}
            minPendingPo={minPendingPo}
            maxPendingPo={maxPendingPo}
            minFutureAts={minFutureAts}
            maxFutureAts={maxFutureAts} maxUnits={maxUnits}
            minAge={minAge} maxAge={maxAge} maxDays={maxDays}
            updateAtsValues={this.updateAtsValues}
            updateFutureAtsValues={this.updateFutureAtsValues}
            updateAgeValues={this.updateAgeValues}
            updateOnHandValues={this.updateOnHandValues}
            updatePendingPoValues={this.updatePendingPoValues}
            contactOptions={contactOptions} contact={contact} status={status} season={season} sortBy={sortBy}
            futureAts={futureAts} vendorOrders={vendorOrders}
            fromDateOnChange={this.fromDateOnChange} toDateOnChange={this.toDateOnChange}
            rep={rep} groupId={groupId} showFields={showFields} fromDate={fromDate} toDate={toDate}
            warehouse={warehouse} factory={factory}
            orgId={customer == null ? null : customer.id}
            customer={customer}
            openShippedByCustomer={this.openShippedByCustomer} isAdmin={isAdmin()}
          />

          <CadCards cads={results} loadMore={this.loadMore} sliceNum={sliceNum}
            markCadAsDeleted={this.markCadAsDeleted} contactOptions={contactOptions}
            shippedData={shippedData} vendorOrders={vendorOrders} receivedContainers={this.state.receivedContainers} inventoryAdjustments={this.state.inventoryAdjustments} salesOrderData={salesOrderData} estimates={estimates} contact={contact} status={status}
            atsRep={atsRep} ticketInfo={ticketInfo} poeInfo={poeInfo} showFields={showFields} fromDate={fromDate} toDate={toDate} cadIds={cadIds} checkboxOnChange={this.checkboxOnChange}
            expandAll={expandAll} laFashionCombine={laFashionCombine} correctPin={this.state.correctPin}
            orgId={customer == null ? null : customer.id}
            />
            {showBackToTop ? (
            <div className="cads2-back-to-top-wrap">
              <Button
                type="button"
                className="cads2-back-to-top-button"
                onClick={this.scrollToTop}
                aria-label="Back to top"
              >
                <span className="cads2-back-to-top-icon">
                  <Icon name="arrow up" />
                </span>
                <span>Back to top</span>
              </Button>
            </div>
          ) : null}
        </div>
      </Transition>
    )
  }
}


export default connect(
  state => ({cadReducer: state.cadReducer}),
  dispatch => ({actions: bindActionCreators(cadActions, dispatch)})
)(CadsPage2)
